import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { BoxClass } from '../../../helper/classes'
import { Button, Card, Checkbox, EditableText, Icon, InputGroup } from '@blueprintjs/core'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import { uniqueId, delay } from 'lodash'
import { reorderForBnD } from '../../../helper/functions'
import { GlobalContext, globalOnDemandVars } from '../../../helper/context'
import { produce } from 'immer'
import * as shortid from 'shortid'
import { useTranslation } from 'react-i18next'

function TodoListAddOn ({ withInputFocus, forDialog }) {
  const { t } = useTranslation()
  const contextValue = useContext(GlobalContext)
  const items = useMemo(() => (contextValue.todoListItems), [contextValue.todoListItems])
  const setItems = useMemo(() => (globalOnDemandVars.set_todoListItems), [])
  // const [items, setItems] = useState(globalOnDemandVars.todoListItems())
  // const setAndUpdateItems = useCallback(
  //   (newItems) => {
  //     setItems(newItems)
  //     globalOnDemandVars.set_todoListItems(newItems)
  //   },
  //   []
  // )

  const [isDragging, setIsDragging] = useState(false)
  const onDragStart = useCallback(
    () => { setIsDragging(true) },
    []
  )
  const onDragEnd = useCallback((result) => {
    setIsDragging(false)
    if (!result.destination) {
      return
    }

    const nextItems = reorderForBnD(
      items,
      result.source.index,
      result.destination.index
    )
    setItems(nextItems)
  }, [items, setItems])

  const [inputValue, setInputValue] = useState('')

  const deleteItem = useCallback(
    (id) => {
      // console.tron.display({
      //   name: 'deleteItem 0',
      //   preview: id,
      //   value: {
      //     items
      //   }
      //   // , important: true
      // })
      delay(() => {
        const globalItems = globalOnDemandVars.todoListItems()
        const newItems = Array.from(globalItems)
        const itemIndex = newItems.findIndex((item) => (item.id === id))
        newItems.splice(itemIndex, 1)
        // console.tron.display({
        //   name: 'deleteItem 1',
        //   preview: id,
        //   value: {
        //     items,
        //     globalItems,
        //     newItems
        //   }
        //   // , important: true
        // })
        setItems(newItems)
      }, 500)
    }
    ,
    [setItems]
  )
  const onConfirm = useCallback(
    () => {
      if (inputValue) {
        setItems(produce(items, draft => {
          draft.unshift({ id: shortid.generate(), title: inputValue, deleteReserved: false })
        }))
        setInputValue('')
      }
    }
    ,
    [inputValue, items, setItems]
  )
  const rightButton = useMemo(() => (<Button minimal icon='plus' onClick={onConfirm} />), [onConfirm])
  const inDroppable = useMemo(() => (items.map((item, i) => {
    if (item.deleteReserved) {
      return null
    }
    let clearDeleteTimer

    return (
      <Draggable key={item.id} draggableId={item.id} index={i}>{
        (provided, snapshot) =>
          (<div ref={provided.innerRef} {...provided.draggableProps} key={item.id} css={css`display: flex;
//font-family: 'hind';
        & .visibleIfHover {
          visibility: hidden;
        }
        &:hover .visibleIfHover {
          visibility: visible;
        }
        & .grabCursor {
          cursor: grab;
        }
        & .grabCursor:active {
          cursor: grabbing;      
        }
      `}>
            <div className={'bp3-button bp3-icon-drag-handle-vertical bp3-minimal visibleIfHover grabCursor'} {...provided.dragHandleProps} />
            <Checkbox large css={css`margin: auto 0 auto 0; flex: auto; font-size: 18px;`} label={item.title}
              onChange={() => {
                if (clearDeleteTimer) {
                  clearTimeout(clearDeleteTimer)
                  clearDeleteTimer = null
                  item.deleteReserved = false
                } else {
                  // clearDeleteTimer = setTimeout(deleteItem, 300, item.id)
                  deleteItem(item.id)
                  item.deleteReserved = true
                }
              }}
            />
            <Button className={'visibleIfHover'} icon={'cross'} minimal
              onClick={() => {
                const newItems = Array.from(items)
                newItems.splice(i, 1)
                setItems(newItems)
              }}
            />
          </div>)
      }</Draggable>
    )
  })
  ), [deleteItem, items, setItems])

  const inputRef = useRef(null)
  useEffect(() => {
    if (withInputFocus) { inputRef.current.focus() }
  }, [withInputFocus])
  useEffect(() => {
    globalOnDemandVars.set_focusTodoListInput(() => {
      inputRef.current.focus()
      return inputRef.current.focus
    })
    return () => {
      globalOnDemandVars.set_focusTodoListInput(() => { return false })
    }
  }, [])

  return useMemo(() => (<div css={css`padding: 0; text-align: left; min-width: 50%; display: flex; flex-direction: column; ${forDialog ? 'height: calc(100% - 8px); margin: 4px;' : 'margin: 0; height: 100%;'}`}>
    <InputGroup placeholder={t('Add a To Do item (alt + t Anywhere)')} large css={css`
& > input {
  border-radius: var(--s-1);
}
`}
      value={inputValue} onChange={(e) => { setInputValue(e.target.value) }} rightElement={rightButton}
      onKeyDown={(e) => {
      if (e.keyCode === 13) {
        onConfirm()
      }
    }}
      inputRef={inputRef} />
    <Card css={css`margin-top: 1.5em; border-radius: 0.66em !important;`}>
      <div css={css`flex: auto; overflow: auto;`}>
        <DragDropContext
          // TODO 항목 아무것도 없으면 null 시키기
          // onBeforeDragStart={onBeforeDragStart}
          onDragStart={onDragStart}
          // onDragUpdate={onDragUpdate}
          onDragEnd={onDragEnd}
        >
          <Droppable droppableId='todoList'>
            {(provided, snapshot) => (
              <div
                ref={provided.innerRef}
                style={{
                  backgroundColor: (isDragging && !snapshot.isDraggingOver) ? '#FFB366' : 'transparent'
                }}
                {...provided.droppableProps}
              >
                {inDroppable}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext></div>
    </Card>
  </div>), [forDialog, inDroppable, inputValue, isDragging, onConfirm, onDragEnd, onDragStart, rightButton])
}

const TodoListAddOnBoxClass = new BoxClass(TodoListAddOn, 'To Do List', null, 3, { order: 8 })

export default TodoListAddOnBoxClass
export { TodoListAddOn }
